// extracted by mini-css-extract-plugin
module.exports = {"smallLoader":"b-z","loader":"c-z","loading-keyframes":"d-z","pageLoader":"e-z","centered":"f-z","whitespacePlaceholder":"g-z","buttonSpinner":"h-z","fade-in":"i-z","rotate":"j-z"};